module.exports = __webpack_public_path__ + "img/we-call-you-96bf2522.png";